module.exports = __webpack_public_path__ + "static/DNA-Explorer-Carrier-white-61de3a33b407d35077adf9ac62fc7233.png";